import { useState } from "react";
import { Form } from "react-bootstrap";
import Recaptcha from "react-google-recaptcha";
import LoginFunctions from "./LoginFunctions";
import TextInput from "shared/components/input/TextInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-hot-toast";
import { usePostRedefinirSenha } from "hooks/login/usePostRedefinirSenha";
import { ResetSenhaSchema } from "shared/yup/schemas/ResetarSenhaSchema";
export interface ResetSenhaForm {
  email: string;
}

const ForgotPassword = () => {
  const { register, control, handleSubmit, setError, clearErrors, getFieldState, setValue } =
    useForm<ResetSenhaForm>({
      resolver: yupResolver<ResetSenhaForm>(ResetSenhaSchema),
    });

  const { mutateAsync: postRedefinirSenha } = usePostRedefinirSenha(setError);

  const [recaptchaIsValid, setRecaptchaIsValid] = useState<boolean>();
  const [recaptcha, setRecaptcha] = useState<Recaptcha | null>(null);
  const { handleVerifyRecaptcha } = LoginFunctions();

  const submitForgotPassword = async (email: string, isRecaptchaValid: boolean | undefined) => {
    if (isRecaptchaValid) {
      await postRedefinirSenha({ email: email });
    } else {
      toast.error("Recaptcha inválido.");
    }
  };
  const handleRecaptchaIsValid = (value: boolean) => {
    setRecaptchaIsValid(value);
  };

  const renderHeaderForgotPassword = () => {
    return (
      <div className="d-flex flex-column text-center mt-5">
        <div className="fs-4 mb-2">Redefinição de senha</div>
        <div style={{ fontSize: "2.5vh" }}>
          Digite o seu e-mail para receber as instruções de <br /> recuperação de senha
        </div>
      </div>
    );
  };

  const renderCampoEmail = () => {
    return (
      <TextInput
        name="email"
        usarValidacaoParaFormulario
        id="email"
        control={control}
        label="E-mail"
        placeholder="Digite seu e-mail"
        register={register}
        setValue={setValue}
        onChange={() => {
          if (getFieldState("email").error?.type === "emailNotFound") {
            clearErrors("email");
          }
        }}
      />
    );
  };

  const renderRecaptcha = () => {
    return (
      <div className="d-flex flex-column align-items-center mt-5">
        <Recaptcha
          ref={(r) => setRecaptcha(r)}
          sitekey="6LeMMI4UAAAAAHEh1XQO1cXbN2ORjOY93vM8SoU_"
          onChange={(e: string | null) =>
            handleVerifyRecaptcha(e, handleRecaptchaIsValid, recaptcha)
          }
          hl="pt-BR"
        />
      </div>
    );
  };

  const renderBotaoSubmit = () => {
    return (
      <div className="d-grid gap-2 mt-5">
        <button
          className={"botao-entrar"}
          type="button"
          onClick={handleSubmit((data) => submitForgotPassword(data.email, recaptchaIsValid))}
        >
          Enviar
        </button>
      </div>
    );
  };

  return (
    <>
      {renderHeaderForgotPassword()}
      <Form className="p-5">
        {renderCampoEmail()}
        {renderRecaptcha()}
        {renderBotaoSubmit()}
      </Form>
    </>
  );
};

export default ForgotPassword;
